import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { rootRoute } from './root'
import { RouteError } from '@lunary/ui-web/screen-state'

export const expertReadingRoute = createRoute({
  path: 'readings/client/$readingId',
  getParentRoute: () => rootRoute,
  component: lazyRouteComponent(() => import('../features/readings/expert-chat-page'), 'ExpertChatPage'),
  errorComponent: RouteError,
})
